import fetcher from '@http/fetch.js'

import { service, fetchPrefix } from '@config/config.js'
import storage from '@mixin/storage'

/**
 * 微信支付
 */
export const fetchWechatPay = data => fetcher(`${service.auto}${fetchPrefix}/api/pay`, data,  'post')
/**
 * 【支付】订单
 * orderSn 订单号 true
 * payType 支付类型 1:微信app支付 2:微信公众号支付 3:微信H5支付 true
 */
export const fetchShopPay = data => fetcher(`${service.auto}${fetchPrefix}/shop/api/shop/pay`, data, 'POST')

/**
 * 图片上传（file格式上传）
 * ******referer=http://xxx.pcauto.com.cn/admin/***** 不需要登录标识符
 * data { String } [true] file
 */
export const fetchUpLoadImg1 = data => {
    if (!data) {
        console.warn('data不能为空')
        return
    }
    let formData = new FormData()
    formData.append('photoFile', data)
    
    return fetcher(`${service.upc}/upload_quick.jsp?referer=http://xxx.pcauto.com.cn/admin/&keepSrc=yes&readExif=no&application=play`, formData, 'post' )
}
/**
 * 上传图片
 * application: "play",
 * readExif: "yes",
 * keepSrc: "yes",
 * data: _data //base64字符
 */
export const fetchUpLoadImg2 = data => {
    data = {
        application: "play",
        readExif: "yes",
        keepSrc: "yes",
        data
    }
    return fetcher(`${service.upc}/upload_quick_base64.jsp?referer=http://xxx.pcauto.com.cn/admin/`, data, 'post')
}

/**
 * 事件计数器
 * id { string } 事件计数器id
 */
export const countAd = (id) => {
    var img = new Image;
    img.src = `//count.pcauto.com.cn/count.php?channel=${id}&screen=${screen.width}*${screen.height}&refer=${encodeURIComponent(document.referrer)}&anticache=${new Date().getTime()}&url=${encodeURIComponent(location.href)}&from=event`
}
/**
 * 栏目计数器
 * id { string } 栏目计数器id
 */
export const countColumnAd = (id) => {
    var img = new Image;
    img.src = `//count.pcauto.com.cn/count.php?channel=${id}&screen=${screen.width}*${screen.height}&refer=${encodeURIComponent(document.referrer)}&anticache=${new Date().getTime()}&url=${encodeURIComponent(location.href)}`
}

/**
 * 请求综合页数据
 * 
 */
export const fetComposite = (data) => fetcher(`${service.auto}
/auto/api/composite`, data, 'get')

/**
 * 请求综合页匹配多类型数据
 * 
 */
export const fetCommonEntities = (data) => fetcher(`${service.auto}
/auto/api/intent-analyzer/entities`, data, 'get')


/**
 * 请求联想词数据
 * 
 */
// export const fetCompletion = (data) => fetcher(`${service.auto}/auto/api/completion`, data, 'get')
export const fetCompletion = (data) => fetcher(`${service.auto}/auto/api/keywords/suggest?&app=compositef&responseEncoding=utf-8`, data, 'get')

/**
 * 请求视频页数据
 * 
 */
export const fetVideoData = (data) => fetcher(`${service.auto}/auto/api/video`, data, 'get')

/**
 * 请求文章页
 * 
 */
export const fetArticleCms = (data) => fetcher(`${service.auto}/auto/api/cms`, data, 'get')

/**
 * 请求论坛页数据
 * 
 */
export const fetBbs = (data) => fetcher(`${service.auto}/auto/api/bbs`, data, 'get')

/**
 * 请求右侧豆腐块-车系专区
 * 
 */
export const fetRightCars = (data) => fetcher(`${service.price}/price/api/v1/serialgroup/ksauto/99999/page`, data, 'get', false)

/**
 * 请求右侧豆腐块-品牌专区
 * 
 */
export const fetRightBrand = (data) => fetcher(`${service.price}/price/api/v1/brand/ksauto/99999/page`, data, 'get', false)

/**
 * 请求右侧豆腐块-厂商专区
 * 
 */
export const fetRightVendor = (data) => fetcher(`${service.price}/price/api/v1/manufacturer/ksauto/99999/page`, data, 'get', false)

/**
 * 请求右侧豆腐块-车系可能关注
 * 
 */
export const fetRightCarsConcern = (data) => fetcher(`${service.price}/price/api/v1/serialgroup/ksauto/99999/other`, data, 'get', false)

/**
 * 请求右侧豆腐块-品牌可能关注
 * 
 */
export const fetBrandConcern = (data) => fetcher(`${service.price}/price/api/v1/brand/ksauto/99999/other`, data, 'get', false)

/**
 * 请求右侧豆腐块-厂商可能关注
 * 
 */
export const fetVdendorConcern = (data) => fetcher(`${service.price}/price/api/v1/manufacturer/ksauto/99999/other?fid=3`, data, 'get', false)


/**
 * 请求bbs头部模块收藏状态
 * 
 */
export const fetCollectionStatus = (data) => fetcher(`https://club.pcauto.com.cn/bbsapi/1.0/club/isBindUserForum.do`, data , 'get',true)
/**
 * 请求bbs头部模块收藏或取消
 * 
 */
export const fetCollection = (data) => fetcher(`//club.pcauto.com.cn/bbsapi/1.0/club/bindOrUnbindUserForum.do`, data , 'POST',true,false)

/**
 * 请求百科
 * 
 */
export const fetBaike = (data) => fetcher(`${service.auto}/auto/api/baike`, data, 'get')

/**
 * 请求太平洋号(行家)数据
 * 
 */
export const fetHj = (data) => fetcher(`${service.auto}/auto/api/expert`, data, 'get')

/**
 * 请求综合页右侧热门推荐
 * 
 */
// export const fetIndexHotRecommended = (data) => fetcher(`https://club.pcauto.com.cn/appapi/2.0/subject/hotSubjectList.do?pageSize=5&pageNo=1&resp_enc=gbk`, data, 'get')

/**
 * 请求综合页顶部品牌区域
 * 
 */
export const fetIndexBrand = (data) => fetcher(`${service.price}/price/api/v1/brand/ksauto/99999`, data, 'get',false)

/**
 * 请求综合页顶部品牌区域的数据筛选变化
 * 
 */
export const fetIndexBrandDataChange = (data) => fetcher(`${service.price}/price/api/v1/brand/ksauto/99999`, data, 'get',false)

/**
 * 请求综合页顶部厂商区域的数据筛选变化
 * 
 */
export const fetIndexVendor = (data) => fetcher(`${service.price}/price/api/v1/manufacturer/ksauto/99999`, data, 'get',false)

/**
 * 请求综合页顶部车系区域的数据筛选变化
 * 
 */
export const fetIndexSerial = (data) => fetcher(`${service.price}/price/api/v1/serialgroup/ksauto/serial?sid=${data.sid}`, {
    headers: { 'Content-Type':'application/x-www-form-urlencoded' }
}, 'post',false)

/**
 * 请求本地车系最低价
 * 
 */
export const fetSerialMinprice = (data) => fetcher(`${service.price}/dealer/interface/price/getLowestModelPrice.jsp`, data, 'get',false)

/**
 * 请求本地分期
 * 
 */
export const fetSerialInstallment = (data) => fetcher(`https://jr.pcauto.com.cn/interface/outer/auto/getProducts.jsp`, data, 'get',false)

/**
 * 请求综合页行情模块
 * 
 */
// export const fetIndexMarket = (data) => fetcher(`${service.price}/interface/ksauto/ksauto_reduce_price.jsp`, data, 'get',false)
export const fetIndexMarket = (data) => fetcher(`${service.bTag}/interface/qd/news/markList.xsp`, data, 'get',false)

/**
 * 请求综合页品牌图片
 * 
 */
export const fetIndexBrandPhoto = (data) => fetcher(`${service.price}/price/api/v1/brand/ksauto/99999/photo`, data, 'get',false)

/**
 * 请求综合页厂商图片
 * 
 */
export const fetIndexVendorPhoto = (data) => fetcher(`${service.price}/price/api/v1/manufacturer/ksauto/99999/photo`, data, 'get',false)

/**
 * 请求综合页车系图片
 * 
 */
export const fetIndexSerailPhoto = (data) => fetcher(`${service.price}/price/api/v1/serialgroup/ksauto/99999/photo`, data, 'get',false)

/**
 * 请求综合页论坛数据
 * 
 */
export const fetIndexBbsInfo = (data) => fetcher(`${service.bbs}/intf/special/_autoForumAdmin.jsp?&retBbs=true&count=3`, data, 'get')

/**
 * 请求综合页点评
 * 
 */
export const fetIndexComment = (data) => fetcher(`${service.price}/price/api/v1/serialgroup/ksauto/99999/comment`, data, 'get',false)

/**
 * 请求综合页接口返回的条件选车接口
 * 
 */
export const fetIndexConditionUrl = (url) => fetcher(`${url}`, {}, 'get',false)

/**
 * 请求综合页标签词
 * 
 */
export const fetIndexTagWord = (data) => fetcher(`${service.cmsTag}/api/tagword/ks`, data, 'get')

/**
 * 请求获取用户信息
 * 
 */
export const fetUserInfo = (data) => fetcher(`https://my.pcauto.com.cn/intf/getLogedUser.jsp`, data, 'get')

/**
 * 请求获取搜索的的类型
 * 
 */
export const fetType = (data) => fetcher(`${service.auto}/auto/api/analyze`, data, 'get')
/**
 * 请求获取广告
 * 
 */
export const fetRecommend = (data) => fetcher('//jzz.pcauto.com.cn/competitor/recommend.do', data, 'get', false)

/**
 * 请求车系补贴价格接口
 */
 export const fetchSerialGroupBtPrice = (data) => fetcher(`${service.price}/price/api/v1/serialgroup/serial_group_bt_data/r${data.cid}-sg${data.sid}`, {},  'get', false)

/**
 * 请求价格
 */
 export const fetchLowestModelPrice = (data) => fetcher(`${service.bTag}/qd/price/intf/dealer/getLowestModelPrice`, data,  'get', false)
 
 /**
 * 请求本地经销商优惠价格接口
 */
 export const fetchMaxDiscount = (data) => fetcher(`${service.bTag}/interface/qd/news/maxDiscount.xsp`, data,  'get', false)

/**
 * 请求车型补贴价格接口
 */
 export const fetchSerialGroupBtPriceList = (data) => fetcher(`${service.price}/price/api/v1/serialgroup/serial_group_bt_data_list`, data,  'get', false)


/**
 * 请求热词搜索接口
 */
export const fetchHotWord = (data) => fetcher(`${service.gateway}/model/api/search/hotWord`, data,  'post')


/**
 * 搜索配置
 * @returns 
 */
export const getSearchConfig = (data) => fetcher(`${service.mb}/configs/search_config`, data, 'get')
